import { IUsuario } from '@/@types/Comunidade';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { FaSquarePhone } from 'react-icons/fa6';
import { MdEmail } from 'react-icons/md';
import { getFotoUrl } from '@/lib/utils';

interface IFuncionario extends IUsuario {}

interface IFuncionarioItemProps {
    data: IFuncionario;
}

const FuncionarioItem = ({ data }: IFuncionarioItemProps) => {
    // console.log(data)
    
    const splitEmail = (email: string) => {
        return email.replace(/\./g, '. ').replace(/@/g, ' @');
    }

    return (
        <div className='flex gap-4 mt-4 items-center border-b-[1px] pb-3 font-normal'>
            <div>
                <Avatar className='w-[120px] h-[120px]'>
                    <AvatarImage src={getFotoUrl(data.foto)} />
                    <AvatarFallback className='text-3xl'>{data.displayName.split('')[0]}</AvatarFallback>
                </Avatar>
            </div>

            <div className='flex flex-col gap-2'>
                <span className='capitalize font-normal'>{data.displayName} ({data.ra}) {data.lattes && (
                    <>
                        <span>|</span>
                        <a href={data.lattes} target='_blank' className='font-semibold'>Lattes</a>
                    </>
                )}</span>

                <p>{data.secaoOrgao?.secaoDescricao}</p>
                <i>{data.funcao}</i>

                <div className='flex gap-1 flex-col md:flex-row md:items-center md:gap-3'>
                    <div className='flex items-center gap-1'>
                        <FaSquarePhone color='#004882' />
                        <span>{data.telefone}</span>
                    </div>

                    <div className='flex items-center gap-1'>
                        <MdEmail color='#004882' />
                        <span>
                            {splitEmail(data.email)}
                        </span>
                    </div>
                </div>

            </div>
        </div>
    );
}

export { FuncionarioItem };